import { colors } from '@fronton/tokens';
import clsx from 'clsx';
import { passthrough, useStyleProps } from '../utils';
import styles from './styles.module.css';
export function useThemeProvider(props) {
  const {
    theme = 'light',
    override,
    children
  } = props;
  const predefinedTheme = predefinedThemes[theme];
  const themeIsClassName = typeof theme === 'string' && !predefinedTheme;
  const partialThemeIsClassName = typeof override === 'string';
  let {
    style
  } = useStyleProps({
    ...theme,
    ...(!override || partialThemeIsClassName ? {} : override)
  }, themeHandlers);
  const className = clsx(styles.themeProvider, styles.tokens, predefinedTheme, themeIsClassName && theme, partialThemeIsClassName && override);
  return {
    style,
    className,
    children
  };
}
const predefinedThemes = {
  light: styles.lightTheme
};
let themeHandlers = {};
for (const color of Object.keys(colors)) {
  themeHandlers[color] = [`--${color}`, passthrough];
}